import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowsAllSides2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrows-all-sides-2, scan, move, focus"} maskId="square-filled-radius-0-stroke-1-IconArrowsAllSides2"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H9V4H4V9H3V3ZM15 3H21V9H20V4H15V3ZM4 15V20H9V21H3V15H4ZM21 15V21H15V20H20V15H21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowsAllSides2;
